import { getApiBaseUrl } from '../../../utils/apiBaseUrl';

/** A user's avatar image URL served by the backend (`/api/users/avatar/:id`).
 *  The `<Avatar>` falls back to initials on a 404, so an unknown/undefined user is safe. */
export const rushMidAvatarUrl = (userId?: string | null): string | undefined =>
  userId ? `${getApiBaseUrl()}/api/users/avatar/${userId}` : undefined;
